import React, { useMemo, useState } from "react";
import TabBar from "../TabBar";
import EntityUsersTable from "./Users/EntityUsersTable";
import EntityHeader from "./EntityHeader";
import ContractedPharmaciesTable from "./ContractedPharmaciesTable";

const TABS = { pharmacies: "Contract Pharmacies", users: "Users" };
const ACTIVE_TAB_STORAGE_KEY = "entityProfileActiveTab";

const getInitialTab = () => {
  const storedTab = window.sessionStorage.getItem(ACTIVE_TAB_STORAGE_KEY);

  return Object.values(TABS).includes(storedTab) ? storedTab : TABS.pharmacies;
};

const EntityProfile = (props) => {
  const [activeTab, setActiveTab] = useState(getInitialTab);
  const [users, setUsers] = useState(props.users || []);

  const admin = useMemo(
    () =>
      [...users]
        .filter((u) => u.role === "admin")
        .sort((a, b) => new Date(a.admin_since) - new Date(b.admin_since))[0],
    [users]
  );

  const handleSetActiveTab = (tab) => {
    window.sessionStorage.setItem(ACTIVE_TAB_STORAGE_KEY, tab);
    setActiveTab(tab);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case TABS.users:
        return (
          <EntityUsersTable
            can_manage_users={props.can_manage_users}
            organization_id={props.organization_id}
            entity={props.entity}
            users={users}
            setUsers={setUsers}
            current_user_id={props.current_user_id}
          />
        );
      case TABS.pharmacies:
        return <ContractedPharmaciesTable {...props} />;
      default:
        return null;
    }
  };

  return (
    <>
      <EntityHeader
        entity={props.entity}
        entities={props.entities}
        path={props.path}
        admin={admin}
        eligibility_file_url={props.eligibility_file_url}
        user_count={users.length}
      />
      <div className="content__caddy">
        <TabBar
          tabs={[TABS.pharmacies, TABS.users]}
          activeTab={activeTab}
          setActiveTab={handleSetActiveTab}
          noMargin
        />
        {renderTabContent()}
      </div>
    </>
  );
};

export default EntityProfile;
